/*
 * Layout Name: About Values
 * Desc:
 */
// libs
import React, { useState } from "react"
import AnimateHeight from "react-animate-height"
import ReactMarkdown from "react-markdown"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import * as styles from "./AboutValues.module.scss"
import Section from "@components/structure/Section/Section"
// components
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"

const Value = (props) => {
  const { value, num } = props
  const [height, setHeight] = useState(0)

  let background = styles.blue
  if (num % 4 === 0) {
    background = styles.orange
  } else if (num % 4 === 2) {
    background = styles.pink
  }

  return (
    <div className={`${styles.value} ${background}`}>
      <h3>{value.title}</h3>
      <AnimateHeight duration={300} height={height}>
        <ReactMarkdown className={styles.text}>{value.text}</ReactMarkdown>
      </AnimateHeight>

      <button type="button" onClick={() => setHeight(height === 0 ? "auto" : 0)}>
        <span>{height !== 0 ? "-" : "+"}</span> {height === 0 && "tell me more"}
      </button>
    </div>
  )
}

const AboutValues = (props) => {
  const { ourValues } = props

  const sliderSettings = {
    className: "black-arrows",
    slidesToShow: 3,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  const slides =
    ourValues && ourValues.length ? ourValues.map((value, i) => <Value key={value.id} value={value} num={i} />) : null

  return slides ? (
    <section className={styles.AboutValues}>
      <SiteWrapper>
        <Section>
          <h1 className={styles.title}>Our Values</h1>
          <Slider className={styles.slider} {...sliderSettings}>
            {slides}
          </Slider>
        </Section>
      </SiteWrapper>
    </section>
  ) : null
}

export default AboutValues
